import React from "react"

const SectionTitle = ({ title }) => {
  return (
      <h4 className="center">{title}</h4>
  )
}
SectionTitle.defaultProps = {
  title:``
}


export default SectionTitle
